import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AuthProvider } from './context/AuthContext';
import { createAppRouter } from './HomeRoutes';
import AppShell from './AppShell';
import './styles.css';

const router = createAppRouter();
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
});

createRoot(document.getElementById('root')).render(
    <QueryClientProvider client={queryClient}>
        {/* <React.StrictMode> */}
        <AuthProvider>
            <AppShell>
                <RouterProvider router={router} />
            </AppShell>
        </AuthProvider>
        {/* </React.StrictMode> */}
    </QueryClientProvider>
);
